import React from "react";
import HeaderComponent from "../WebSite/Header/HeaderComponent";
import FooterComponent from "../WebSite/Footer/FooterComponent";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import { Container } from "@material-ui/core";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import "./CBO.css";
import CBOChallenges from "./CBOChallenges";
import CBOService from "./CBOService";
import CBOBenefits from "./CBOBenefits";
import CBOCustomerBenefits from "./CBOCustomerBenefits";
import CTA from "../CTA/CTA";
import CBOPricing from "../pricingTabs/CBOPricing";
import AgriBusinessCard from "../AgriBusinessCard/AgriBusinessCard";
import TitleDescription from "../TitleDescription/TitleDescription";

export default function CBO() {
  return (
    <>
      <HeaderComponent />
      <UpdatesBanner
        bannerText="Community Based Network"
        className="CBO-banner-bg"
      />
      {/* <Container>
        <TitleDescription
          classname=""
          title="Who are Community Based Organisations"
          description={[
            "Community-based organizations (CBOs) in are grassroots groups formed by individuals within a community to collectively address agricultural challenges and enhance rural livelihoods. These organizations play a pivotal role in promoting sustainable farming practices, improving access to markets and resources, and strengthening community ties. By fostering collaboration and knowledge-sharing, CBOs contribute to the overall development of agriculture, empower small-scale farmers, and address specific issues in farming, thereby promoting resilient and inclusive agricultural systems at the local level.",
          ]}
        />
      </Container> */}
      {/* <CBOTypes/> */}
<Container>
      <div className=" subSectionWrapper mb-0 ">
              <TitleDescription
                titleClass="text-start"
                classname2="text-start"
                classname="mb-0 mt-0"
                title="Who are Community Based Organisations
                "
                description={[
                  "Community-based organizations (CBOs) in are grassroots groups formed by individuals within a community to collectively address agricultural challenges and enhance rural livelihoods. These organizations play a pivotal role in promoting sustainable farming practices, improving access to markets and resources, and strengthening community ties. By fostering collaboration and knowledge-sharing, CBOs contribute to the overall development of agriculture, empower small-scale farmers, and address specific issues in farming, thereby promoting resilient and inclusive agricultural systems at the local level.                  "
                  // 'An agri-entrepreneur can be an aspiring agri-producer  or an organization that can get into different levels of entrepreneurships in the agri-food sector by leveraging  digital  Transformation in agri-food industry. As an Agri-Entrepreneur partner of GBR farming, the aspiring agri-producer or  organizations can truly become a "Farm-to-Factory digital enterprise"',
                  // <br className="d-block pb-4"></br>,

                  // "GBR will provide digital technology and tools for Agri-Entrepreneurs to manage and operate their farms or / and other agri-producers’ farms. GBR will also facilitate the Agri entrepreneurs with financial assistance for installing micro-processing units to process the farm outputs and training to ensure the effective usage of the processing units.",
                ]}
              />

              <AgriBusinessCard />
            </div>
            </Container>
      <CBOChallenges />
      <SolutionEcosystem
        type="CBO"
        bodycopy="System and Process for CBO to create, manage and own LTN ( Local Trade Network ) for efficient local trade"
      />
      <CBOService/>
      <CBOBenefits />
      <CBOCustomerBenefits />

<Container>
<h2 className="container-title text-center ">CBO Pricing</h2>

<CBOPricing/>
<div className=" subSectionWrapper">
            <CTA
              href="/auth/3/signup"
              heading="

              Elevate your impact — join our CBON Network and unlock growth opportunities now!"
              btnText="Register Now"
              onClick={()=>{
                localStorage.setItem("userType", "CBO")
              }}
            />
          </div>
          </Container>
      <FooterComponent />
    </>
  );
}
